/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VideoYouTubeErrorType = {
    YoutubeDownloadError: 'YOUTUBE_DOWNLOAD_ERROR',
    AwsUploadError: 'AWS_UPLOAD_ERROR'
} as const;
export type VideoYouTubeErrorType = typeof VideoYouTubeErrorType[keyof typeof VideoYouTubeErrorType];

